import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IEppType {
  eppTypeID: number;
  name: string;
}

export const getEppTypes = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/EppType', config);
  return response.data;
};
